define('app-Agents/modules/modules',[
    "./common/module",
    "./header/module",
    "./passwordStrength/module",
    "./forms/module"
], function (common, header, passwordStrength, forms) {
    return [
        common,
        header,
        passwordStrength,
        forms
    ];
});
